import React from "react"
import { WorkshopQuoteImageTextType } from "../../types/mainModulTypes"
import { API } from "../../constants/constants"
import BaseQuoteText from "../common/BaseQuoteText"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"

export default function WorkshopQuoteImageText(props: WorkshopQuoteImageTextType) {
    return (
        <div className="">
            <div className="bg-primary flex items-start rounded-default py-12 sm:py-16 gap-3 -mt-16 px-4 mx-4 md:mx-0">
                <BaseQuoteText text={props.workshopQuoteImageTextQuote} isQuoteWhite={props.workshopQuoteImageTextQuoteToggle} />
            </div>
            <div className=" max-w-content mx-auto flex flex-col md:flex-row items-center gap-4 sm:gap-8 pt-8 md:py-16 px-4 lg:px-0">
                <img
                    src={API + props.workshopQuoteImageTextImage?.url}
                    alt={props.workshopQuoteImageTextImage?.description ?? props.workshopQuoteImageTextImage?.name}
                    className="w-full md:w-1/2 aspect-[4/3] object-cover rounded-default border-4 border-primary"
                />
                <div className="border-x-4 border-transparent md:border-none">
                    <BaseSubheadline label={props.workshopQuoteImageTextHeading} />
                    <BaseRichtext content={props.workshopQuoteImageTextText} />
                </div>
            </div>
        </div>
    )
}
